import React, { useState, useEffect } from 'react'

import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	MenuItem,
	TextField,
	Typography
} from '@material-ui/core'

import { makeStyles, confirmActivation } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	}
}))

const ActivationDialog = (props) => {
	const classes = useStyles()

	let { isShown, setIsShown, confirmActivation } = props

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 24
				}}>
				SENDING ACTIVATION EMAIL
			</DialogTitle>
			<DialogContent>
				<Typography
					variant="body2"
					style={{
						marginBottom: 24
					}}>
					Once sent, the client will be able to set their password and log into the client app. Are you
					sure you’d like to continue?
				</Typography>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" onClick={() => confirmActivation()} color="secondary">
					CONFIRM ACTIVATION
				</Button>
				<Button variant="outlined" onClick={() => setIsShown(false)} color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default ActivationDialog
